import { alpha, useTheme } from '@mui/material/styles';

const useCssReset = () => {
  const { breakpoints, palette } = useTheme();

  const cssReset = {
    // Reset CSS
    '*': {
      margin: 0,
      padding: 0,
      boxSizing: 'border-box',
      textUnderlineOffset: '2px',
      scrollbarColor: `${alpha(palette.grey[600], 0.48)} !important`,
      [breakpoints.down('xs')]: { scrollbarWidth: '0px !important' },
      [breakpoints.up('xs')]: { scrollbarWidth: '0px !important' },
      [breakpoints.up('sm')]: { scrollbarWidth: '2px !important' },
      [breakpoints.up('lg')]: { scrollbarWidth: '4px !important' },
      '&::-webkit-scrollbar': {
        [breakpoints.down('xs')]: { width: '0px !important' },
        [breakpoints.up('xs')]: { width: '0px !important' },
        [breakpoints.up('sm')]: { width: '2px !important' },
        [breakpoints.up('lg')]: { width: '4px !important' }
      },
      '&::-webkit-scrollbar-track': {
        background: 'initial !important', // color of the tracking area
        zIndex: '-1 !important',
        width: '0px !important',
        borderRadius: '10px !important'
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: `${alpha(palette.grey[600], 0.48)}!important`, // color of the scroll thumb
        borderRadius: '10px !important' // roundness of the scroll thumb
      },
      '&::-webkit-scrollbar-button': {
        display: 'none'
      },
      '::selection': {
        backgroundColor: palette.primary.lightest
      }
    },

    html: {
      height: '100%',
      width: '100%'
    },

    body: {
      height: '100%',
      width: '100%',
      overflow: 'hidden',
      background: 'red',
      [breakpoints.up('xs')]: { background: palette.appBackground.main },
      [breakpoints.up('sm')]: { background: palette.appBackground.gradient },
      [breakpoints.up('lg')]: { background: palette.appBackground.gradient }
    },

    '#root': {
      height: '100%',
      width: '100%',
      overflow: 'auto',
      '&::-webkit-scrollbar-track': {
        [breakpoints.down('xs')]: { marginTop: '64px !important', marginBottom: '88px !important' },
        [breakpoints.up('xs')]: { marginTop: '64px !important', marginBottom: '88px !important' },
        [breakpoints.up('sm')]: { marginTop: '64px !important', marginBottom: '0px !important' },
        [breakpoints.up('lg')]: { marginTop: '92px !important' }
      }
    },

    iframe: {
      border: 0
    },

    input: {
      caretColor: palette.primary.main,
      '&[type=number]': {
        MozAppearance: 'textfield',
        '&::-webkit-outer-spin-button': { margin: 0, WebkitAppearance: 'none' },
        '&::-webkit-inner-spin-button': { margin: 0, WebkitAppearance: 'none' }
      }
    },

    textarea: {
      '&::-webkit-input-placeholder': { color: palette.text.disabled },
      '&::-moz-placeholder': { opacity: 1, color: palette.text.disabled },
      '&:-ms-input-placeholder': { color: palette.text.disabled },
      '&::placeholder': { color: palette.text.disabled }
    },

    img: {
      display: 'block',
      height: 'auto',
      width: '100%',
      maxWidth: '100%',
      // Tricks to hide the alt text without a JS function to reach the #shadow root DOM element
      // https://stackoverflow.com/questions/22051573/how-to-hide-image-broken-icon-using-only-css-html/32928240#32928240
      textIndent: '-10000px'
    },

    svg: {
      display: 'block' // Evite que le SVG ait une marge bottom indésirable
    },

    pre: {
      whiteSpace: 'pre-line',
      overflowWrap: 'anywhere'
    },

    td: {
      height: 1 // Required CSS hack for height 100% on children
    }
  };

  return { cssReset };
};

export default useCssReset;
